@if (isLoading() && isEmpty()) {
  <app-invitation-channel-history-skeleton [count]="1" [variant]="variant()" />
} @else if (isEmpty()) {
  <div
    class="tw-flex tw-w-full tw-flex-col tw-items-center tw-justify-center tw-gap-4 tw-rounded-md tw-py-4"
    [ngClass]="variant() === 'dark' ? 'tw-text-gray-300' : 'tw-text-gray-700'"
  >
    <div
      class="tw-flex tw-shrink-0 tw-items-center tw-justify-center tw-rounded-lg"
      [ngClass]="
        variant() === 'dark'
          ? 'tw-h-9 tw-w-9 tw-bg-gray-700'
          : 'tw-h-12 tw-w-12 tw-bg-gray-200'
      "
    >
      <img
        [src]="emptyIconSrc()"
        alt=""
        [attr.aria-hidden]="true"
        [ngClass]="variant() === 'dark' ? 'tw-h-5 tw-w-5' : 'tw-h-6 tw-w-6'"
        [attr.width]="variant() === 'dark' ? 20 : 24"
        [attr.height]="variant() === 'dark' ? 20 : 24"
      />
    </div>
    <p
      class="tw-m-0 tw-font-inter tw-leading-normal"
      [ngClass]="
        variant() === 'dark'
          ? 'tw-whitespace-nowrap tw-text-xs tw-font-medium tw-text-gray-300'
          : 'tw-text-center tw-text-sm tw-font-normal tw-text-gray-700'
      "
    >
      {{ emptyCopy() }}
    </p>
  </div>
} @else {
  <div class="tw-flex tw-w-full tw-flex-col tw-overflow-y-auto" [ngClass]="maxHeightClass()" (scroll)="onHistoryScroll($event)">
    @for (entry of entries(); track entryTrackKey(entry, $index); let last = $last) {
      <div
        class="tw-flex tw-w-full tw-flex-col tw-gap-1 tw-py-4"
        [ngClass]="{
          'tw-border-b': !last || isLoadingMore(),
          'tw-border-gray-700': variant() === 'dark' && (!last || isLoadingMore()),
          'tw-border-gray-200': variant() === 'light' && (!last || isLoadingMore())
        }"
      >
        <div class="tw-flex tw-w-full tw-items-center tw-justify-between tw-gap-2">
          <div class="tw-flex tw-min-w-0 tw-items-center tw-gap-2">
            <span class="tw-h-2.5 tw-w-2.5 tw-shrink-0 tw-rounded-full" [ngClass]="statusDotClass(entry.status)"></span>
            <p
              class="tw-m-0 tw-truncate tw-font-medium tw-leading-normal tw-font-inter"
              [ngClass]="variant() === 'dark' ? 'tw-text-xs tw-text-gray-200' : 'tw-text-sm tw-text-gray-900'"
            >
              {{ formatHistoryDate(entry.created_at) }}
            </p>
          </div>
          <span
            class="tw-inline-flex tw-shrink-0 tw-items-center tw-rounded-md tw-font-medium tw-leading-none tw-font-inter tw-text-xs tw-capitalize tw-py-0.5 tw-px-2.5 tw-h-[22px]"
            [ngClass]="badgeClass(entry.status)"
          >
            {{ formatHistoryStatus(entry.status) }}
          </span>
        </div>
        <p
          class="tw-m-0 tw-pl-[18px] tw-font-normal tw-leading-normal tw-font-inter"
          [ngClass]="variant() === 'dark' ? 'tw-text-xs tw-text-gray-400' : 'tw-text-sm tw-text-gray-500'"
        >
          By: {{ entry.by }}
        </p>
      </div>
    }
    @if (isLoadingMore()) {
      <app-invitation-channel-history-skeleton [count]="1" [variant]="variant()" [heightPx]="null" />
    }
  </div>
}
